import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import ViewNewCoupon from '../views/ViewNewCoupon.vue'
import ListCoupons from '../views/ListCoupons.vue'
import NotFound from '../views/NotFound.vue'

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: '/:session',
    name: 'New Coupon',
    component: ViewNewCoupon,
    props: true
  },
  {
    path: '/listagem-cupons/:session',
    name: 'List Coupons',
    component: ListCoupons,
    props: true
  },
  {
    path: '*',
    name: 'NotFound',
    component: NotFound,
    props: true
  }
];

const router = new VueRouter({
  mode: 'history',
  routes,
});

export default router;
